import { TrialType } from '@zapier/design-system-revenue/src/types';

type TrialUrls = {
  [x in TrialType]: string;
};

const trialUrls: TrialUrls = {
  Professional: '/sign-up',
  Team: '/app/team-account-setup',
  Company: '/app/company-account-setup',
};

export const getTrialUrl = (trialType: TrialType) => trialUrls[trialType];
